<section class="main py-0 h-100vh" [class.banner-hidden]="hideBanner">
    <div class="container-fluid full-width d-flex flex-column overflow-hidden series-view h-100" *ngIf="channel">
        <show-details-banner class="series-hero w-100" [class.hide]="hideBanner" [seriesView]="true" [heroWeb]="imageWeb"
                             [heroMobile]="imageMobile" [logo]="logo" [media]="channel.media[0]"></show-details-banner>


        <div class="show-details-wrapper">
            <div class="show-details-container">
                <div class="divider"></div>
                <div class="show-seasons">

                    <div dpadZone="'episodes-selectors'" class="season-episodes" dpadScrollableVertical>
                        <ng-container *ngFor="let item of channel.media; let i = index">
                            <div class="episode" (focus)="episodeFocus(item.id, i)"
                                 [class.dpad-zone-start]="item.id === selectedMediaId" [class.dpad-start]="i === 0"
                                 (click)="redirectToVideo(item.mediaId)" (keyup.enter)="redirectToVideo(item.mediaId)"
                                 [scrollTo]="true" dpadSelectable>
                                <div class="episode-image">
                                    <video-thumb-show-details [media]="item"></video-thumb-show-details>

                                </div>
                                <div class="episode-details">
                                    <div class="episode-title">
                                        {{item.title}}
                                    </div>
                                    <div class="episode-description">
                                        {{item.shortDescription}}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
